import { useContext, useEffect, useState } from 'react'
import { DatePicker, Select, Table, Row, Col, message, Checkbox, Switch, Space } from 'antd'
import moment from 'moment';

import './styles.css'

import { Context } from '../../context'
import { Fetch } from '../../fetch'
import { convertIdToKey, handleExportClick } from '../../utils'
import { CheckCircleFilled, CloseCircleOutlined, CloudDownloadOutlined } from '@ant-design/icons'

const { Column } = Table
const dateFormat = 'YYYY-MM-DD HH:mm:ss';

const ManageOrders = () => {
    const { token, apiUrl } = useContext(Context)

    const [orders, setOrders] = useState([])
    const [loading, setLoading] = useState(false)
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
    const [filters, setFilters] = useState({ date: [moment().startOf('month'), moment().endOf('month')], plan: null, paid: true, currency: null });
    const [plans, setPlans] = useState([]);
    const [resellerPlans, setResellerPlans] = useState([]);
    const [applePlans, setApplePlans] = useState([]);
    const [allPlans, setAllPlans] = useState([]);

    const handleTableDataChange = (page) => {
        let f = filters;
        let planstring = f.plan ? `plan=${f.plan}` : null;
        let sdate = moment(f.date[0]).isValid() ? moment(f.date[0]).format(dateFormat) : null
        let edate = moment(f.date[1]).isValid() ? moment(f.date[1]).format(dateFormat) : null
        let datestring = sdate && edate ? `start_date=${sdate}&end_date=${edate}` : ``;
        let paidstring = f.paid ? `paid=${true}` : `paid=${false}`;
        let currencystring = f.currency ? `currency=${f.currency}` : ``;
        let fstring = `${planstring}&${datestring}&${paidstring}&${currencystring}`

        Fetch(
            `${apiUrl}/orders?current=${page.current}&size=${page.pageSize}&${fstring}`,
            token,
            (result) => {
                const orders = convertIdToKey(result.orders)
                setOrders(orders)
                setPagination(prev => {
                    return {
                        ...page,
                        total: result.total
                    }
                })
            }
        )
    }


    useEffect(() => {
        handleTableDataChange(pagination)
        if ('length' in plans && plans.length === 0) {
            Fetch(
                `${apiUrl}/plans/admin`, token, (result) => {
                    const plans = convertIdToKey(result.plans)

                    plans.forEach(plan => {
                        const type_of_isprivate = typeof (plan.isPrivate);

                        if ((type_of_isprivate == "undefined") || (plan.isPrivate == "False")) {
                            plan.isPrivate = "public";
                        } else {
                            plan.isPrivate = "private";
                        }
                    })
                    setResellerPlans(plans)
                })

            Fetch(`${apiUrl}/plans?type=web`, token, (result) => {
                const plans = convertIdToKey(result.plans)
                setPlans(plans)
            })

            Fetch(`${apiUrl}/plans?type=apple`, token, (result) => {
                const plans = convertIdToKey(result.plans)
                plans.forEach(plan => {
                    plan.name = plan.planId
                    plan.enrichedName = plan.name + " (Apple)"
                })
                setApplePlans(plans)
            })
        }
    }, [apiUrl, token, filters])

    useEffect(() => {
        if (allPlans.length === 0 && resellerPlans.length !== 0 && plans.length !== 0 && applePlans.length !== 0) {
            let temp_plans = [...resellerPlans, ...plans, ...applePlans]
            setAllPlans(temp_plans)
        }
    }, [resellerPlans, plans, applePlans])

    const recheckPayment = (id) => {
        setLoading(true)
        let url = ``;
        if (id && id.includes("pp_")) {
            url = `${apiUrl}/pporders/${id}`;
        }
        if (id && id.includes('order_'))
            url = `${apiUrl}/orders/${id}`;
        Fetch(url,
            token,
            (result) => {
                if (result.paid) {
                    setOrders(orders.map(order => order.key === id ? { ...order, paid: true } : order))
                }
            }
        )
        setLoading(false)
    }


    return (
        <div className="manage-orders-wrapper">
            <Row style={{ marginBottom: "20px" }} align={'middle'} >

                <Col span={2} > Paid <Switch checked={filters.paid ? true : false}
                    onChange={(checked) => setFilters({ ...filters, paid: checked ? true : false })} />
                </Col>
                <Col span={4} >
                    <Select style={{ width: "100%" }} placeholder={"Filter by currency"} allowClear
                        onChange={(value) => setFilters({ ...filters, currency: value })}
                    >
                        {['INR', 'USD'].map(code =>
                            <Select.Option key={code} value={code}  >{code}</Select.Option>)}
                    </Select>
                </Col>
                <Col span={4}>
                    <Select style={{ width: "100%" }}
                        placeholder={"Filter by Plan"} value={filters.plan}
                        allowClear onChange={(value) => setFilters({ ...filters, plan: value })}>
                        {allPlans.map((plan, index) => {
                            return <Select.Option key={index} value={plan.name}>{plan.enrichedName ? plan.enrichedName : plan.name}</Select.Option>
                        })}
                    </Select> </Col>
                <Col span={6}>
                    <DatePicker.RangePicker style={{ width: "100%" }}
                        defaultValue={[moment(filters.date[0], dateFormat), moment(filters.date[1], dateFormat)]}
                        onChange={(value, dateString) => setFilters({ ...filters, date: dateString ? dateString : ['', ''] })}
                        format={dateFormat}
                    /></Col>
                <Col>
                </Col>
            </Row>

            <Table
                dataSource={orders}
                pagination={pagination}
                onChange={handleTableDataChange}
            >
                <Column title="ID" dataIndex="key" key="key" align="center" />
                <Column title="User" dataIndex="user" key="language" align="center" />
                <Column title="Date" dataIndex="date" key="date" align="center" render={(_, record) => record.date ? moment(record.date).format(dateFormat) : '-'} />
                <Column title="Plan" dataIndex="plan" key="plan" align="center"
                />
                <Column title="Amount" dataIndex="amount" key="amount" align="center" render={(_, record) => `${record.currency} ${record.amount}`} />
                <Column title="Discount Used" dataIndex="discountCode" key="discountCode" align="center" render={code => code === 'None' ? '-' : code} />
                <Column
                    title="Paid"
                    dataIndex="paid"
                    key="paid"
                    align="center"
                    render={paid => paid ? <CheckCircleFilled /> : <CloseCircleOutlined />}
                />
                <Column title="Actions" align="center" render={(_, record) => record.paid ? "-" : record.pg && record.pg === "PhonePe" ? <a onClick={() => recheckPayment(record.key)} disabled={loading}>Recheck Status</a> : "-"} />
            </Table>
            <CloudDownloadOutlined className="export-btn-only" onClick={() => handleExportClick(apiUrl, token, 'orders')} />
        </div>
    )
}

export default ManageOrders
